import styled from "styled-components"
import quotation from "../../../static/quotation.svg"

const PersonsStyled = styled.div`
  .person__container {
    max-width: 750px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 70px;
    position: relative;
    @media (max-width: 880px) {
      flex-wrap: wrap;
      padding-top: 60px;
    }
  }
  .person__description {
    position: relative;
    max-width: 530px;
    margin-bottom: -5px;
    @media (max-width: 880px) {
      max-width: 100%;
      width: 100%;
    }
    &:before {
      content: "";
      width: 30px;
      height: 30px;
      display: block;
      position: absolute;
      top: -10px;
      left: -40px;
      background: url(${quotation});
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 650px) {
        content: unset;
      }
    }
    p {
      margin: 0;
      font-size: 18px;
      font-weight: 300;
      padding-bottom: 20px;
    }
    a {
      display: block;
      width: max-content;
      @media (max-width: 650px) {
        word-wrap: break-word;
        display: block;
        max-width: 100%;
      }
      img {
        margin-right: 13px;
      }
    }
  }
  .person__email {
    padding-bottom: 10px;
    font-size: 18px;
    font-weight: 300;
    transition: 0.3s all;
    @media (max-width: 500px) {
      font-size: 14px;
    }
    &:hover {
      opacity: 0.5;
    }
  }
  .person__linkedin {
    transition: 0.3s all;
    &:hover {
      opacity: 0.5;
    }
  }
  .person__image {
    display: flex;
    flex-direction: column;
    @media (max-width: 880px) {
      max-width: 100%;
      width: 100%;
      padding-top: 30px;
      align-items: center;
      justify-content: center;
    }
    &:after {
      content: "";
      position: absolute;
      display: block;
      width: calc(100% - 50px);
      margin-left: auto;
      height: 1px;
      background: #d8d8d8;
      right: 17px;
      bottom: 0;
      @media (max-width: 880px) {
        content: unset;
      }
    }
  }
`

export default PersonsStyled
